import React from 'react';

interface SubjectPerformanceProps {
  reportCard: any;
  formatTime: (seconds: number) => string;
}

const SubjectPerformance: React.FC<SubjectPerformanceProps> = ({ reportCard, formatTime }) => {
  if (!reportCard) return null;

  return (
    <div className="row g-4 mb-4">
      <div className="col-md-6">
        <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '15px' }}>
          <div className="card-header bg-transparent border-0 pt-4">
            <h5 className="card-title fw-bold mb-0">
              <i className="fas fa-books me-2 text-primary"></i>
              Subject Performance
            </h5>
          </div>
          <div className="card-body">
            {reportCard.subject_wise_stats && Array.isArray(reportCard.subject_wise_stats) && reportCard.subject_wise_stats.map((stats: any, index: number) => (
              <div key={index} className="mb-3">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <span className="fw-semibold">{stats.subject_name}</span>
                  <span className="badge bg-primary">{parseFloat(stats.accuracy).toFixed(1)}%</span>
                </div>
                <div className="progress" style={{ height: '8px' }}>
                  <div
                    className="progress-bar"
                    style={{ width: `${Math.min(parseFloat(stats.accuracy), 100)}%` }}
                  ></div>
                </div>
                <small className="text-muted">
                  {stats.correct_answers}/{stats.questions_attempted} correct • {formatTime(parseInt(stats.total_time))}
                </small>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="col-md-6">
        <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '15px' }}>
          <div className="card-header bg-transparent border-0 pt-4">
            <h5 className="card-title fw-bold mb-0">
              <i className="fas fa-layer-group me-2 text-success"></i>
              Difficulty Analysis
            </h5>
          </div>
          <div className="card-body">
            {reportCard.difficulty_wise_stats && Array.isArray(reportCard.difficulty_wise_stats) && reportCard.difficulty_wise_stats.map((stats: any, index: number) => (
              <div key={index} className="mb-3">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <span className="fw-semibold">{stats.difficulty}</span>
                  <span className="badge bg-success">{parseFloat(stats.accuracy).toFixed(1)}%</span>
                </div>
                <div className="progress" style={{ height: '8px' }}>
                  <div
                    className="progress-bar bg-success"
                    style={{ width: `${Math.min(parseFloat(stats.accuracy), 100)}%` }}
                  ></div>
                </div>
                <small className="text-muted">
                  {stats.correct_answers}/{stats.questions_attempted} correct
                </small>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubjectPerformance;
